import { Materia } from '@shared/data-structure/interfaces';

export function getDataMaterias(): any {
  const dataMaterias: Materia[] = [
    {
      legalmattercode: 1,
      legalMatter: 'Derecho Administrativo',
      url: '/materia/administrativo-procedimiento-administrativo',
      color: '72FEF3',
    },
    {
      legalmattercode: 6,
      legalMatter: 'Derecho Comercial',
      url: '/materia/comercial',
      color: 'FFFF00',
    },
    {
      legalmattercode: 21,
      legalMatter: 'Derecho Penal',
      url: '/materia/penal-procesal-penal',
      color: '67FF03',
    },
    {
      legalmattercode: 5,
      legalMatter: 'Derecho Civil',
      url: '/materia/civil',
      color: 'D7FF87',
    },
    {
      legalmattercode: 28,
      legalMatter: 'Derecho del Trabajo',
      url: '/materia/trabajo-procedimiento-laboral',
      color: 'C6D09E',
    },
    {
      legalmattercode: 20,
      legalMatter: 'Derecho Notarial',
      url: '/materia/notarial',
      color: 'D4E6A6',
    },
    {
      legalmattercode: 15,
      legalMatter: 'Filosofía del Derecho',
      url: '/materia/filosofia',
      color: 'BCBDC0',
    },
    {
      legalmattercode: 12,
      legalMatter: 'Derechos Humanos',
      url: '/materia/derechos-humanos',
      color: 'F7931D',
    }
  ];
  return dataMaterias;
}
